
import React, {useState,useEffect} from "react";
import Layout from "layouts/layout";
import Table from "components/table/table";
import ListContainer from "components/list/list-container";
import ListHeader from "components/list/list-header";
import { useDialogHook } from "utils/customhooks";
import AddFaviconModal from "./components/add-icon";
import FavIconDeleteModal from "./components/delete-icon";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { urlSerializer } from "utils/utils";
import { useLocation } from "react-router-dom";
import ActionIconBtn from "components/button/action-btn";
import EditPencilIconSVG from "assets/svg/edit-pencil-icon";
import { SET_FAVICON,REFRESH_FAVICON,UPDATE_LOCKED } from "redux/modules/fav-icon/types";
import Toggle from "components/toggle/toggle";
import UserCheckIconSVG from "assets/svg/user-check-icon";
import BlockIconSVG from "assets/svg/block-icon";

export default function FavIconLibrary(){
    const { http } = global.services;
    const query = useQuery()
    const dispatch = useDispatch();
    const searchValue = query.get("search");
    const [filterValue, setFilterValue] = useState(searchValue);
    const _delete = useDialogHook(FavIconDeleteModal); 
    const modal = useDialogHook(AddFaviconModal);
    const [isLoading,setLoading] = useState(false);  
    const columns = [
        {
          title: "Domain",
          dataIndex: "domain",
          nowrap: true,
          key: "domain",
        },
        {
          title: "Icon",
          dataIndex: "favicon_url",
          nowrap: true,
          key: "favicon_url",
          render:(item)=>{
            return <ActionIconBtn
            icon={
                <div className="flex items-center justify-center">
                    <img className="w-6" src={item.favicon_url} alt="Favicon" />
                </div>
            } />
          }
        },
        {
          title: "Locked",
          dataIndex: "locked",
          nowrap: true,
          key: "locked",  
          render:(item)=>{
            return <Toggle 
                    checked={item.locked}
                    disabled={isLoading}
                    onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: "locked",
                            value: e?.target?.checked,
                            id:item.id
                          },
                        })
                      }
                    />
          }
        }, 
        {
            title: "New Icon Available",
            dataIndex: "new_updates",
            nowrap: true,
            key: "new_updates",  
            render:(item)=>{
              return <div className="flex">
                    {
                        item.locked && item.pending_icon_url ?
                        <>
                            <ActionIconBtn
                                icon={<UserCheckIconSVG className="m-auto" />}
                                onClick={() => handleApproveUser(item,'accept')}
                            />
                            <ActionIconBtn
                                icon={<BlockIconSVG className="m-auto" />}
                                onClick={() => handleApproveUser(item,'reject')}
                            />
                            <ActionIconBtn
                                icon={
                                <div className="flex items-center justify-center">
                                    <img className="w-6" src={item.pending_icon_url} alt="Favicon" 
                                />
                                </div>
                            }
                                
                            />
                        </>
                        : <></>
                    }
                        
                </div>
            }
          },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          hideSorting: true,
          nowrap: true,
          render:(item) => (
            <>
                <ActionIconBtn
                icon={<EditPencilIconSVG className="m-auto" />}
                onClick={() => handleAddEdit(item)}
            />
            </>
          )
        },
    ];

     const {
        isRequesting,
        initialize,
        loadMore,
        refresh,
        page,
        limit,
        favicons=[],
        pages = [],
      } = useSelector((state) => state.favicon);

      const handleInputChange = async(e) => {
        const { value, id } = e.target;
        try {
             let list = [...favicons];
             setLoading(true);
            const data = await http.patch(`fav-icons/${id}/lock`);
            if (data) { 
                list = list.map(item => item.id === id ? { ...item, 'locked':value ? 1 : 0 } : item)
                console.log(list);
                dispatch({
                    type: UPDATE_LOCKED,
                    payload: {
                        favicons: list,
                      },
                    id:id
                  });
            }
          } catch (err) {
            console.log("error@handleSubmit", err);
          }finally{
            setLoading(false)
          }
      };

        const handleApproveUser = async(item = {},action) => {
            try{
                let form = new FormData();
                form.append('action', action);
                form.append('_method', 'PUT');
                const data = await http.post(`fav-icons/${item.id}`,form);
            if (data) {
                dispatch({
                  type: REFRESH_FAVICON,
                  payload: [],
                });
              }
            }catch(e){
                console.log(e);
            }
        };

    useEffect(() => {  
        if(initialize)getFavicon();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh, initialize]);


    const handleAddEdit = (data = {}) => {
        modal(data, (result) => {
        if (!_.isEmpty(result)) {
            console.log("result ", result);
          if (result === "addOrUpdate") {
            dispatch({
              type: REFRESH_FAVICON,
              payload: [],
            });
          } else if (result === "delete") {
            handleDelete(data);
          }
        }
        });
    };

    const handleDelete = (data = {}) => {
        _delete(data, (result) => {
            if (!_.isEmpty(result)) {
            console.log("result ", result);
            if (result === "delete") {
                dispatch({
                type: REFRESH_FAVICON,
                payload: [],
                });
            }
            }
        });
        };

    const getFavicon = async (selectedPage = null) => {
        if (isRequesting || !loadMore) return;
    
        // dispatch({ type: GET_USERS, payload: [] });
    
        try {
          const url = urlSerializer("fav-icons", {
            search: filterValue,
            page: selectedPage ?? page,
            limit: limit,
          });
          const { data } = await http.get(url); 
          const _loadMore = data.data.length > 0 ? true : false;
          // const _page = data.data.length > 0 ? page + 1 : page;
          const _page = data.current_page;
          const _lastPage = data.last_page;
    
          dispatch({
            type: SET_FAVICON,
            payload: {
              favicons: data.data,
              loadMore: _loadMore,
              page: _page,
              lastPage: _lastPage,
            },
          });
        } catch (err) {
          console.log("error@getFavicon", err);
        }
      };
    return(
        <Layout title="Fav Icon Library" routeName="fav-icons-library">
            <div className="main-page-wrapper">
                <ListContainer
                    header={
                    <ListHeader
                        title="List"
                        // countValue={_.size(users)}
                        // filterValue={filterValue}
                        // setFilterValue={setFilterValue}
                        buttonName="+ Add Icon"
                        showAddButton={true}
                        onClickButton={() => handleAddEdit()}
                        // onSearch={(e) => handleSearch(e)}
                    />
                    }
                >

                    <Table
                        columns={columns}
                        dataSource={favicons}
                        pagination={true}
                        selectable={true}
                        // selected={selectedRows}
                        // onSelected={(selectedRows) => {
                        //     setSelectedRows(selectedRows);
                        // }}
                        perPage={10}
                        currentPage={page}
                        onHandleChangePage={getFavicon}
                        pages={pages}
                    />
                </ListContainer>
            </div>
        </Layout>
    );
}

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};